import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

import type { ChangeRecord, ChangeHistoryAction } from './utils'
import { ChangeField } from './ChangeField'
import { ChangeFieldWithoutDiff } from './ChangeFieldWithoutDiff'

export type ChangeHistoryRow = {
  id: number
  created_at: string
  created_by: string
  company_id: number
  campaign_id: number | null
  llm_id: number | null
  tool_id: number | null
  type: string
  action: ChangeHistoryAction
  changes: ChangeRecord[]
  campaigns: { name: string } | null
  llms: { name: string; view_type: string } | null
  tools: { name: string } | null
}

type DialogViewDetailsProps = {
  dialogOpen: boolean
  setDialogOpen: (open: boolean) => void
  selectedItem: ChangeHistoryRow
  hasPromptEditor: boolean
}

export function DialogViewDetails({
  dialogOpen,
  setDialogOpen,
  selectedItem,
  hasPromptEditor,
}: DialogViewDetailsProps) {
  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Change Details</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4 border-b pb-4">
            <div>
              <p className="text-body text-gray-500">Date</p>
              <p className="font-medium">
                {new Date(selectedItem.created_at).toLocaleDateString()}{' '}
                {new Date(selectedItem.created_at).toLocaleTimeString()}
              </p>
            </div>
            <div>
              <p className="text-body text-gray-500">User</p>
              <p className="font-medium">{selectedItem.created_by}</p>
            </div>
            <div>
              <p className="text-body text-gray-500">Entity</p>
              <p className="font-medium">
                {selectedItem.campaigns?.name ||
                  selectedItem.llms?.name ||
                  selectedItem.tools?.name ||
                  '-'}
              </p>
            </div>
            <div>
              <p className="text-body text-gray-500">Action</p>
              <p className="font-medium">{selectedItem.action}</p>
            </div>
          </div>

          <div className="space-y-3">
            <h3 className="font-semibold text-heading">Changes</h3>
            {selectedItem.changes.map((change: ChangeRecord, index) => {
              const hideGeneralPrompt =
                !hasPromptEditor &&
                selectedItem.type === 'llm' &&
                selectedItem.llms?.view_type === 'template'
              if (hideGeneralPrompt && change.fieldName === 'general_prompt') {
                return null
              }

              return (
                <div
                  key={`${change.fieldName}-${index}`}
                  className="border rounded-lg p-4 space-y-2"
                >
                  <p className="font-semibold text-gray-700">
                    {change.fieldName}
                  </p>
                  {selectedItem.action === 'update' ? (
                    <ChangeField change={change} />
                  ) : (
                    <ChangeFieldWithoutDiff
                      change={change}
                      action={selectedItem.action}
                    />
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
